import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import type { ApiError } from '../../../lib/errors';

export interface HopXacNhanXoaProps {
  open: boolean;
  onClose: () => void;
  /** Tiêu đề đặt câu hỏi; thân nói hậu quả và tính không hoàn tác. */
  tieuDe: string;
  than: string;
  /** Nhắc lại việc sắp xảy ra: `Xoá lĩnh vực`, không phải `OK`. */
  nhanXacNhan: string;
  dangChay: boolean;
  loi?: ApiError | null;
  onXacNhan: () => void;
}

/**
 * Hộp xác nhận cho hành động phá huỷ của phân hệ.
 *
 * Giữ hộp **mở** khi lỗi: backend chặn xoá lĩnh vực còn loại hồ sơ (409), và câu giải thích đó phải
 * đọc được ngay tại chỗ người dùng vừa bấm, chứ không phải ở một toast đã biến mất.
 */
export function HopXacNhanXoa({
  open, onClose, tieuDe, than, nhanXacNhan, dangChay, loi, onXacNhan,
}: HopXacNhanXoaProps) {
  const { t } = useT();
  const dichLoi = useLoi();

  return (
    <Dialog open={open} onClose={onClose} title={tieuDe}>
      <div className="space-y-4 pt-2">
        <p className="text-sm text-content-secondary">{than}</p>
        {loi && (
          <p className="rounded border border-danger-200 bg-danger-50 p-3 text-sm text-danger-700">{dichLoi(loi)}</p>
        )}
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button variant="destructive" size="md" loading={dangChay} onClick={onXacNhan}>
            {nhanXacNhan}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
